'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = require('./Alert');

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/alert/index.js
// module id = 546
// module chunks = 0